import { render, staticRenderFns } from "./Cipeo.vue?vue&type=template&id=610574de"
import script from "./Cipeo.vue?vue&type=script&lang=ts"
export * from "./Cipeo.vue?vue&type=script&lang=ts"
import style0 from "./Cipeo.vue?vue&type=style&index=0&id=610574de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports